// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FffNv","col":"styles_col__16jbl"};